import React from "react";
import { useNavigate } from "react-router-dom";
import failed from "../../assets/failed1.png";
import BackArrow from "../../Components/BackButton/BackArrow";
import Navigation from "../../Components/Navigation/Navigation";

const TransactionFailed = () => {
  const navigate = useNavigate();
  return (
    <div className="transaction-failed">
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-4 pr-3 pb-4">
          <p className="page-text dashboard">
            <BackArrow />
          </p>
          <div className="successfulPage">
            <img src={failed} alt="Plant" />
            <h2>Oops, something went wrong!</h2>
            <p>
              We're sorry, but it seems that your transaction couldn't be
              completed at the moment.
            </p>
            <div className="transaction-buttons">
              <button
                className="purchase-more-button"
                onClick={() => navigate(-1)}
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionFailed;
